import { Text } from '@blueprintjs/core'
import { TOrderable, useShoppingCartController } from 'client/controllers/cartController'
import { FC } from 'react'

type TProps = {
  data: TOrderable
}

const ProductItem: FC<TProps> = ({ data }) => {
  const {} = useShoppingCartController()
  return (
    <li className="grid grid-cols-12 w-full gap-y-4 gap-x-3">
      <div className="col-span-2 rounded-md overflow-hidden aspect-square">
        <img src={data.product.image} className="w-full h-full object-cover "></img>
      </div>
      <div className="flex col-span-7 flex-col gap-2">
        <Text tagName="span" className="font-body---16px">
          {data.product.name}
        </Text>
        <div className="flex items-center gap-3">
          <Text tagName="span" className="font-body---16px">
            {`€${data.product.price}`}
          </Text>
        </div>
      </div>
      <div className="flex col-span-3 justify-end">
        <Text tagName="span" className="font-body---20px">
          {`€${data.quantity * data.product.price}`}
        </Text>
      </div>
    </li>
  )
}

export { ProductItem }
